import { call, put } from 'redux-saga/effects';

import { createRegistration } from '@api/registrations';
import { registrationsDetailsSetModel } from '@models/Registrations';
import { history, jurisdictionsRoutes } from '@routes';
import { toastError, toastSuccess } from '@store/notifications';
import {
  registrationsInfoCreateSuccessAction,
  registrationsInfoCreateFailureAction,
} from '@store/registrations/registrationsDetail/registrationsInfo/registrationsInfo.actions';

export const registrationsInfoCreateSaga = function* ({ payload = {} }) {
  try {
    const response = yield call(createRegistration, {
      data: registrationsDetailsSetModel({
        ...payload.data,
        entityId: payload.entityId,
      }),
      entityId: payload.entityId,
    });

    yield put([
      registrationsInfoCreateSuccessAction(),
      toastSuccess({
        message: {
          defaultMessage: 'Registration created successfully.',
          id: 'pages.registrations.registration-info-create.notification.success',
        },
      }),
    ]);

    yield call(
      history.replace,
      jurisdictionsRoutes.DETAIL.make({
        entityId: response.entity,
        entityJurisdictionId: response.entityJurisdiction,
      })
    );
  } catch (error) {
    const { fieldErrors, nonFieldErrors, hasNonFieldError, hasFieldError } = error.data || {};

    if (hasFieldError) {
      yield call(payload.setErrors, fieldErrors);
    }

    yield put([
      toastError({
        message: hasNonFieldError
          ? nonFieldErrors
          : {
              defaultMessage: 'Registration creation failed.',
              id: 'pages.registrations.registration-info-create.notification.error',
            },
      }),
      registrationsInfoCreateFailureAction(),
    ]);

    yield call(payload.setSubmitting, false);
  }
};
